function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Object, String, activeEvent, activeEventPart, placeholders, stepRenameModal) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['add-entry-row'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const isDisabled = !$helpers.canAddNewItem();;
        const {
          actions,
          sections
        } = $helpers.getEntityAddActions();;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "key": 'new',
          "class": Object.assign({}, {
            'is-add-row': true,
            'is-disabled': isDisabled,
          }, {
            'mp-query-events-section-event': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((actions && actions.length === 1) ? ((function() {
            var __jade_nodes = [];
            const action = actions[0];;
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "attrs": {
                'disabled': isDisabled,
                'theme': `secondary`,
                'icon': `plus`,
                'testref': `newEntryButton`,
              },
              "on": {
                click: () => $helpers.onAddTypeSelected(action)
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat((!action.iconOnly) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(`Add`);;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : (sections) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-select", {
              "attrs": {
                'disabled': isDisabled,
                'icon': JSON.stringify({
                  leftIcon: `plus`
                }),
                'selected-option': `Add`,
                'menu-width': $attr(`add-entry-menu-width`),
                'sections': JSON.stringify(sections),
                'size': `small`,
                'testref': `typeSelect`,
                'theme': `tertiary`,
                'button-theme': `secondary`,
              },
              "on": {
                change: ev => $helpers.onAddTypeSelected(ev.detail.item),
              },
            }));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['numeric-prop-prefix'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat("aggregated by");;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['numeric-property'] = function(index, entry, selected, isNumericPlaceholder, dataGroupsEnabled, projectHasPeople) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-query-events-section-event-property': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-query-multi-block", {
            "attrs": $helpers.serializeAttributes({
              'type': `properties`,
              'all-data-groups': dataGroupsEnabled,
              'adding-disabled': !isNumericPlaceholder,
              'data-group-id': $attr(`data-group-id`) || entry.dataGroupId,
              'dropdown-alignment': `left`,
              'event-names': [entry.event.value],
              'enable-behavioral-properties': $attr(`enable-behavioral-properties`),
              'include-custom-properties': $attr(`include-custom-properties`),
              'project-id': $attr(`project-id`),
              'user-id': $attr(`user-id`),
              'project-has-events': entry.type === $helpers.ResourceType.Event,
              'project-has-people': projectHasPeople !== false && (entry.type === $helpers.ResourceType.User || entry.type === $helpers.ResourceType.Event),
              'removable': !!selected,
              'selected': isNumericPlaceholder ? null : [selected],
              'button-icon': ``,
              'button-input-only': false,
              'button-is-removable': true,
              'button-selector-type': `text`,
              'button-selector-theme': `builder`,
              'button-open': isNumericPlaceholder,
              'single-data-group': entry.type === $helpers.ResourceType.User && entry.dataGroupId,
              'theme': 'builder',
              'layout': `column`,
              'workspace-id': $attr(`workspace-id`),
            }),
            "dataset": {
              key: `event-property`
            },
            "on": {
              update: ev => $helpers.applyNumericProperty(ev.detail.items[0], index),
              open: () => $helpers.setActiveEvent(`open`, index, $helpers.ActiveEventPart.NumericProperty),
              close: () => $helpers.setActiveEvent(`close`, index, $helpers.ActiveEventPart.NumericProperty),
              track: $helpers.preventTracking,
            },
            "props": {
              prefixRenderer: $mixins[`numeric-prop-prefix`]
            },
          }));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['line-actions'] = function(index, isPlaceholder, entry) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        const {
          type,
          event,
          filters,
          filtersOperator
        } = entry;;
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-query-events-section-event-actions': true
          },
        }, (function() {
          var __jade_nodes = []; /*  aggregator select */
          __jade_nodes = __jade_nodes.concat((!isPlaceholder && $attr(`show-numeric-aggregations`) && !$helpers.isPropertySelectorType(type)) ? ((function() {
            var __jade_nodes = [];
            const sections = $helpers.getAggregatorFunctionsForEntry(index);; /*  hide default/single options */
            __jade_nodes = __jade_nodes.concat((sections.length !== 0) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'mp-query-events-section-event-aggregator': true,
                  'mp-query-events-section-event-action': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-select", {
                  "attrs": {
                    'sections': JSON.stringify(sections),
                    'selected-option': $helpers.getAggregatorFunctionLabelForEntry(index),
                    'searchable': false,
                    'menu-width': 120,
                    'menu-height': 360,
                    'theme': `tertiary`,
                    'button-theme': `tertiary`,
                    'testref': `aggregatorSelect`,
                  },
                  "on": {
                    change: ev => $helpers.updateShowClause(ev, index, $helpers.ActiveEventPart.Aggregator),
                    menuChange: ev => $helpers.onSelectMenuChange(ev, index, $helpers.ActiveEventPart.Aggregator),
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((!isPlaceholder && $helpers.isDateRangeType(type)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-query-events-section-event-action': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-query-block", {
                "attrs": $helpers.getDateRangeAttributes(type, entry.dateRange),
                "on": {
                  select: ev => $helpers.onDateRangeChange(ev, index),
                  track: $helpers.preventTracking,
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat((!isPlaceholder) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'mp-query-events-section-event-action': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-control-bar", {
                "attrs": {
                  testref: `lineActions`,
                  theme: `tertiary`,
                  'overflow-controls': JSON.stringify($helpers.getLineActionControls(index, entry, isPlaceholder)),
                  'overflow-icon': `hor-ellipsis`,
                  'overflow-menu-width': 180,
                  'overflow-menu-alignment': `left`,
                },
                "on": {
                  select: ev => $helpers.onControlSelect(ev.detail.value, index)
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['renaming-modal'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-modal", {
          "attrs": {
            'open': !!stepRenameModal
          },
          "class": {
            'mp-query-events-section-event-rename-modal': true
          },
        }, (function() {
          var __jade_nodes = []; /*  Rendering the input modal for each open, allows us to focus & select it easily. */
          __jade_nodes = __jade_nodes.concat((!!stepRenameModal) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'rename-modal': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'rename-modal-title': true
                },
              }, [__vjadeSafeCode($helpers.stepRenameModal.title())]));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'input-label': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Name");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("input", {
                "attrs": {
                  type: `text`
                },
                "on": {
                  input: $helpers.stepRenameModal.onChangeInput,
                  keyup: $helpers.stepRenameModal.onKeyStroke,
                  change: ev => ev.stopPropagation(),
                },
                "hook": {
                  insert: $helpers.stepRenameModal.onInputElementInserted
                },
                "props": {
                  value: $helpers.stepRenameModal.text()
                },
                "class": {
                  'rename-name-input': true
                },
              }));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'rename-modal-actions': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": {
                    theme: `tertiary`
                  },
                  "on": {
                    click: $helpers.stepRenameModal.close
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Cancel");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(h("mp-button", {
                  "attrs": {
                    theme: `primary`
                  },
                  "on": {
                    click: $helpers.stepRenameModal.submit
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Save");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const showLabels = $attr(`row-label-type`) !== $helpers.RowLabelType.None;;
    const isDraggable = $attr(`row-draggable`);;
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'has-label': showLabels,
          'has-type-icons': $attr(`metrics-mode`),
          'is-empty': $helpers.getEventEntries(false).length === 0,
          'is-draggable': $attr(`row-draggable`),
        }, {
          'mp-query-events-section': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((function() {
          var $$obj = ($helpers.getEventEntries());
          var $$eachNodes;
          var $$iterated = false;
          if (Array.isArray($$obj)) {
            $$eachNodes = $$obj.reduce(function($$eachNodes, entry, index) {
              $$iterated = true;
              return $$eachNodes.concat((function() {
                var __jade_nodes = [];
                const {
                  event,
                  filters,
                  filtersOperator
                } = entry;;
                const isPlaceholder = event.value === null;;
                const isActive = activeEvent === index;;
                const hasFilterItem = filters.length > 0 || placeholders.get(index) === $helpers.EventEntryPlaceholder.Filter;;
                const isClickable = $attr(`row-index-toggleable`) && !isPlaceholder;;
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "key": `${index}-${JSON.stringify(event.value)}`,
                  "attrs": {
                    'draggable': isDraggable,
                    'testref': `eventRow`,
                  },
                  "on": (isDraggable ? {
                    dragstart: ev => $helpers.onEventStepDragStart(ev, index),
                    dragenter: () => $helpers.onEventStepDragEnter(index),
                    dragover: ev => $helpers.onEventStepDragOver(ev, index),
                    dragleave: $helpers.onEventStepDragClear,
                    dragend: $helpers.onEventStepDragClear,
                    drop: ev => $helpers.onEventStepDrop(ev, index),
                  } : {}),
                  "class": Object.assign({}, {
                    'is-active': isActive,
                    'drop-indicator-above': $helpers.isDroppingAbove(index),
                    'drop-indicator-below': $helpers.isDroppingBelow(index),
                    'has-filters': filters.length > 0,
                    'has-property': !!entry.property,
                    'is-placeholder': isPlaceholder,
                    'is-draggable': isDraggable,
                  }, {
                    'mp-query-events-section-event': true
                  }),
                }, (function() {
                  var __jade_nodes = []; /* - dragging control */
                  __jade_nodes = __jade_nodes.concat((isDraggable) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "on": {
                        mousedown: () => $helpers.onGripperMouseDown(index),
                        mouseleave: $helpers.onGripperMouseLeave,
                      },
                      "class": {
                        'mp-query-events-section-event-part': true,
                        'for-gripper': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                        "attrs": {
                          icon: `gripper`
                        },
                      }));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : undefined); /* - Skip putting in a label if this is the only row possible */
                  __jade_nodes = __jade_nodes.concat((showLabels && $attr(`row-limit`) !== 1) ? ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "class": Object.assign({}, {
                        'is-placeholder': isPlaceholder
                      }, {
                        'mp-query-events-section-event-part': true,
                        'for-label': true
                      }),
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("mp-button", {
                        "attrs": {
                          'size': `small`,
                          'theme': `tertiary`,
                        },
                        "on": {
                          click: ev => $helpers.onEventIndexLabelClicked(ev, index)
                        },
                        "class": {
                          'is-clickable': isClickable
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'mp-query-events-section-event-label-text': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat($helpers.getRowLabel(index));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this)) : undefined);
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-query-events-section-event-part': true,
                      'for-type-icon': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                      "attrs": {
                        'icon': $helpers.getSelectedTypeIcon(entry)
                      },
                    }));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));
                  __jade_nodes = __jade_nodes.concat(h("div", {
                    "class": {
                      'mp-query-events-section-event-selector': true
                    },
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("mp-query-event-selector", {
                      "attrs": {
                        'type': entry.type,
                        'open': isPlaceholder && activeEvent === index && activeEventPart === $helpers.ActiveEventPart.Value,
                        'project-id': $attr(`project-id`),
                        'user-id': $attr(`user-id`),
                        'data-groups-enabled': $attr(`data-groups-enabled`),
                        'data-group-id': $attr(`data-group-id`),
                        'disable-event-selection': entry.readOnlyEvent,
                        'exclude-autotrack-events': $attr(`exclude-autotrack-events`),
                        'exclude-close-selectors': JSON.stringify($attr(`exclude-close-selectors`)),
                        'enable-behavioral-properties': $attr(`enable-behavioral-properties`),
                        'include-custom-properties': $attr(`include-custom-properties`),
                        'is-blocked-people': $attr(`is-blocked-people`),
                        'project-has-events': [$helpers.ResourceType.Event, $helpers.SelectorTypeDefinitions.Behavior, $helpers.SelectorTypeDefinitions.EventLaunch].includes(entry.type),
                        'project-has-people': $attr(`project-has-people`) || entry.type === $helpers.SelectorTypeDefinitions.Behavior,
                        'selected-event': JSON.stringify(event),
                        'selected-filters': JSON.stringify(filters),
                        'selected-filters-operator': filtersOperator,
                        'hide-edit-controls': $attr(`hide-edit-controls`),
                        'show-any-event': $attr(`show-any-event`),
                        'show-session-event': $attr(`show-sessions`),
                        'show-all-events': $attr(`show-all-events`),
                        'show-top-events': $attr(`show-top-events`),
                        'show-type-icons': $attr(`metrics-mode`),
                        'support-b2b-cohorts': $attr(`support-b2b-cohorts`),
                        'support-inline-cohorts': $attr(`support-inline-cohorts`),
                        'show-placeholder': placeholders.get(index) === $helpers.EventEntryPlaceholder.Filter,
                        'show-special-date-property': $attr('show-special-date-property'),
                        'show-special-date-property-unit': $attr('show-special-date-property-unit'),
                        'workspace-id': $attr(`workspace-id`),
                      },
                      "on": {
                        deletedCustomEvent: () => $helpers.onEventActionClick({
                          action: $helpers.Action.Remove,
                          index
                        }),
                        savedCustomEvent: $helpers.propagateEvent,
                        open: () => $helpers.setActiveEvent(`open`, index, $helpers.ActiveEventPart.Value),
                        close: () => $helpers.setActiveEvent(`close`, index, $helpers.ActiveEventPart.Value),
                        select: ev => $helpers.onEventSelected(ev, index, isPlaceholder),
                        track: ev => $helpers.trackEventSelectorEvent(ev, index, isPlaceholder),
                      },
                      "class": {
                        'is-placeholder': isPlaceholder,
                      },
                    }, (function() {
                      var __jade_nodes = []; /*  line actions (event-suffix) */
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "attrs": {
                          slot: 'event-suffix'
                        },
                        "class": {
                          'mp-query-events-section-event-suffix': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(($helpers.isExclusionStepsSection() && !isPlaceholder) ? ((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'mp-query-events-section-event-action': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("mp-step-range-selector", {
                              "attrs": {
                                'selected': JSON.stringify($helpers.exclusionSteps.getExclusionStep(index)),
                                'num-steps': $helpers.exclusionSteps.getNumExclusionSteps(),
                                'theme': 'builder',
                                'label': 'between',
                              },
                              "on": {
                                select: ev => $helpers.exclusionSteps.onExclusionStepSelected(ev, index)
                              },
                            }));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this)) : undefined);
                        __jade_nodes = __jade_nodes.concat(jade_mixins['line-actions'].call(this, index, isPlaceholder, entry));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      const selectedNumericProp = $helpers.getSelectedNumericProperty(index);;
                      const isNumericPlaceholder = placeholders.get(index) === $helpers.EventEntryPlaceholder.Property;;
                      __jade_nodes = __jade_nodes.concat(((selectedNumericProp || isNumericPlaceholder) && !$helpers.isPropertySelectorType(entry.type)) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "attrs": {
                            slot: `event-row`
                          },
                          "class": Object.assign({}, {
                            'has-filters': hasFilterItem
                          }, {
                            'mp-query-events-section-event-numeric-property': true
                          }),
                        }, (function() {
                          var __jade_nodes = []; /*  numeric property selector */
                          __jade_nodes = __jade_nodes.concat(jade_mixins['numeric-property'].call(this, index, entry, selectedNumericProp, isNumericPlaceholder, $attr(`data-groups-enabled`), $attr(`project-has-people`)));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : undefined);;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this));
            }, []);
          } else {
            $$eachNodes = [];
            for (var $$objKey in $$obj) {
              (function() {
                var index = $$objKey;
                if ($$obj.hasOwnProperty(index)) {
                  $$iterated = true;
                  var entry = $$obj[index];
                  $$eachNodes = $$eachNodes.concat((function() {
                    var __jade_nodes = [];
                    const {
                      event,
                      filters,
                      filtersOperator
                    } = entry;;
                    const isPlaceholder = event.value === null;;
                    const isActive = activeEvent === index;;
                    const hasFilterItem = filters.length > 0 || placeholders.get(index) === $helpers.EventEntryPlaceholder.Filter;;
                    const isClickable = $attr(`row-index-toggleable`) && !isPlaceholder;;
                    __jade_nodes = __jade_nodes.concat(h("div", {
                      "key": `${index}-${JSON.stringify(event.value)}`,
                      "attrs": {
                        'draggable': isDraggable,
                        'testref': `eventRow`,
                      },
                      "on": (isDraggable ? {
                        dragstart: ev => $helpers.onEventStepDragStart(ev, index),
                        dragenter: () => $helpers.onEventStepDragEnter(index),
                        dragover: ev => $helpers.onEventStepDragOver(ev, index),
                        dragleave: $helpers.onEventStepDragClear,
                        dragend: $helpers.onEventStepDragClear,
                        drop: ev => $helpers.onEventStepDrop(ev, index),
                      } : {}),
                      "class": Object.assign({}, {
                        'is-active': isActive,
                        'drop-indicator-above': $helpers.isDroppingAbove(index),
                        'drop-indicator-below': $helpers.isDroppingBelow(index),
                        'has-filters': filters.length > 0,
                        'has-property': !!entry.property,
                        'is-placeholder': isPlaceholder,
                        'is-draggable': isDraggable,
                      }, {
                        'mp-query-events-section-event': true
                      }),
                    }, (function() {
                      var __jade_nodes = []; /* - dragging control */
                      __jade_nodes = __jade_nodes.concat((isDraggable) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "on": {
                            mousedown: () => $helpers.onGripperMouseDown(index),
                            mouseleave: $helpers.onGripperMouseLeave,
                          },
                          "class": {
                            'mp-query-events-section-event-part': true,
                            'for-gripper': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                            "attrs": {
                              icon: `gripper`
                            },
                          }));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : undefined); /* - Skip putting in a label if this is the only row possible */
                      __jade_nodes = __jade_nodes.concat((showLabels && $attr(`row-limit`) !== 1) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": Object.assign({}, {
                            'is-placeholder': isPlaceholder
                          }, {
                            'mp-query-events-section-event-part': true,
                            'for-label': true
                          }),
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("mp-button", {
                            "attrs": {
                              'size': `small`,
                              'theme': `tertiary`,
                            },
                            "on": {
                              click: ev => $helpers.onEventIndexLabelClicked(ev, index)
                            },
                            "class": {
                              'is-clickable': isClickable
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'mp-query-events-section-event-label-text': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat($helpers.getRowLabel(index));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)) : undefined);
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'mp-query-events-section-event-part': true,
                          'for-type-icon': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                          "attrs": {
                            'icon': $helpers.getSelectedTypeIcon(entry)
                          },
                        }));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'mp-query-events-section-event-selector': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("mp-query-event-selector", {
                          "attrs": {
                            'type': entry.type,
                            'open': isPlaceholder && activeEvent === index && activeEventPart === $helpers.ActiveEventPart.Value,
                            'project-id': $attr(`project-id`),
                            'user-id': $attr(`user-id`),
                            'data-groups-enabled': $attr(`data-groups-enabled`),
                            'data-group-id': $attr(`data-group-id`),
                            'disable-event-selection': entry.readOnlyEvent,
                            'exclude-autotrack-events': $attr(`exclude-autotrack-events`),
                            'exclude-close-selectors': JSON.stringify($attr(`exclude-close-selectors`)),
                            'enable-behavioral-properties': $attr(`enable-behavioral-properties`),
                            'include-custom-properties': $attr(`include-custom-properties`),
                            'is-blocked-people': $attr(`is-blocked-people`),
                            'project-has-events': [$helpers.ResourceType.Event, $helpers.SelectorTypeDefinitions.Behavior, $helpers.SelectorTypeDefinitions.EventLaunch].includes(entry.type),
                            'project-has-people': $attr(`project-has-people`) || entry.type === $helpers.SelectorTypeDefinitions.Behavior,
                            'selected-event': JSON.stringify(event),
                            'selected-filters': JSON.stringify(filters),
                            'selected-filters-operator': filtersOperator,
                            'hide-edit-controls': $attr(`hide-edit-controls`),
                            'show-any-event': $attr(`show-any-event`),
                            'show-session-event': $attr(`show-sessions`),
                            'show-all-events': $attr(`show-all-events`),
                            'show-top-events': $attr(`show-top-events`),
                            'show-type-icons': $attr(`metrics-mode`),
                            'support-b2b-cohorts': $attr(`support-b2b-cohorts`),
                            'support-inline-cohorts': $attr(`support-inline-cohorts`),
                            'show-placeholder': placeholders.get(index) === $helpers.EventEntryPlaceholder.Filter,
                            'show-special-date-property': $attr('show-special-date-property'),
                            'show-special-date-property-unit': $attr('show-special-date-property-unit'),
                            'workspace-id': $attr(`workspace-id`),
                          },
                          "on": {
                            deletedCustomEvent: () => $helpers.onEventActionClick({
                              action: $helpers.Action.Remove,
                              index
                            }),
                            savedCustomEvent: $helpers.propagateEvent,
                            open: () => $helpers.setActiveEvent(`open`, index, $helpers.ActiveEventPart.Value),
                            close: () => $helpers.setActiveEvent(`close`, index, $helpers.ActiveEventPart.Value),
                            select: ev => $helpers.onEventSelected(ev, index, isPlaceholder),
                            track: ev => $helpers.trackEventSelectorEvent(ev, index, isPlaceholder),
                          },
                          "class": {
                            'is-placeholder': isPlaceholder,
                          },
                        }, (function() {
                          var __jade_nodes = []; /*  line actions (event-suffix) */
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "attrs": {
                              slot: 'event-suffix'
                            },
                            "class": {
                              'mp-query-events-section-event-suffix': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(($helpers.isExclusionStepsSection() && !isPlaceholder) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'mp-query-events-section-event-action': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("mp-step-range-selector", {
                                  "attrs": {
                                    'selected': JSON.stringify($helpers.exclusionSteps.getExclusionStep(index)),
                                    'num-steps': $helpers.exclusionSteps.getNumExclusionSteps(),
                                    'theme': 'builder',
                                    'label': 'between',
                                  },
                                  "on": {
                                    select: ev => $helpers.exclusionSteps.onExclusionStepSelected(ev, index)
                                  },
                                }));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : undefined);
                            __jade_nodes = __jade_nodes.concat(jade_mixins['line-actions'].call(this, index, isPlaceholder, entry));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));
                          const selectedNumericProp = $helpers.getSelectedNumericProperty(index);;
                          const isNumericPlaceholder = placeholders.get(index) === $helpers.EventEntryPlaceholder.Property;;
                          __jade_nodes = __jade_nodes.concat(((selectedNumericProp || isNumericPlaceholder) && !$helpers.isPropertySelectorType(entry.type)) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "attrs": {
                                slot: `event-row`
                              },
                              "class": Object.assign({}, {
                                'has-filters': hasFilterItem
                              }, {
                                'mp-query-events-section-event-numeric-property': true
                              }),
                            }, (function() {
                              var __jade_nodes = []; /*  numeric property selector */
                              __jade_nodes = __jade_nodes.concat(jade_mixins['numeric-property'].call(this, index, entry, selectedNumericProp, isNumericPlaceholder, $attr(`data-groups-enabled`), $attr(`project-has-people`)));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this)) : undefined);;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this));
                }
              })();
            }
          }

          return $$eachNodes;
        })()); /*  new row controls */
        __jade_nodes = __jade_nodes.concat(($helpers.canAddRow()) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(jade_mixins['add-entry-row'].call(this));;
          return __jade_nodes
        }).call(this)) : undefined); /*  renaming modal */
        __jade_nodes = __jade_nodes.concat(($attr(`can-rename-step`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(jade_mixins['renaming-modal'].call(this));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "activeEvent" in locals ? locals.activeEvent : typeof activeEvent !== "undefined" ? activeEvent : undefined, "activeEventPart" in locals ? locals.activeEventPart : typeof activeEventPart !== "undefined" ? activeEventPart : undefined, "placeholders" in locals ? locals.placeholders : typeof placeholders !== "undefined" ? placeholders : undefined, "stepRenameModal" in locals ? locals.stepRenameModal : typeof stepRenameModal !== "undefined" ? stepRenameModal : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;